<script lang="ts">
	//Svelte hooks
	import { format } from 'svelte-i18n';
	//Helpers
	import { status_configurator } from '../../../helpers/device_data_helpers';
	import { real_id } from 'src/helpers/interface_helpers';
	//Stores
	import { getDeviceState } from 'src/stores/device-runtime/states';
	import { getDeviceSettings, getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	//Device system components
	import { IconButton, Icon } from '@Shelly/shelly-design-system';
	//Components
	import MainControlStatusSlot from '../Devices/MainControlStatusSlot.svelte';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { getSubtitleClasses } from '@Shelly/shelly-design-system/AdvancedCard/advanced-card-helpers';
	import AuthenticateDevice from 'src/components/Devices/DeviceWizard/AuthenticateDevice.svelte';

	export let device;

	let statuses;
	let authenticate;

	$: deviceStateStore = getDeviceState(device?.id);
	$: statusStore = getDeviceStatus(real_id(device?.id));
	$: settingsStore = getDeviceSettings(real_id(device?.id));
	$: deviceState = $deviceStateStore;
	$: status = $statusStore;
	$: settings = $settingsStore;
	$: isLoading = deviceState?.isLoading;
	$: icon = deviceState?.icon;
	$: description = deviceState?.description;
	$: notAuthenticated = deviceState?.type === 9;
	$: if (Object.keys(device).length && Object.keys(deviceState).length) {
		statuses = status_configurator(status, device, settings);
	}
</script>

{#if status?.online}
	<MainControlStatusSlot type={'widget'} {device} {status} {settings} {statuses} {isLoading} />
{:else if notAuthenticated}
	<IconButton
		size="m"
		{icon}
		class="mb-m"
		on:click={(e) => {
			e.stopPropagation();
			authenticate = true;
		}}
		aria-label={$format('aria_authenticate_device', {
			default: 'Authenticate device',
		})}
	/>
{:else}
	<Icon
		size="m"
		{icon}
		class={classMap(getSubtitleClasses(description || { value: '', type: 'default' }))}
	/>
{/if}
{#if authenticate}
	<AuthenticateDevice {device} bind:showModal={authenticate} />
{/if}
